<template>
    <eSesjaModal>
        <eSesjaModalHeader @close="$store.commit('setModalConfirmCreateNewCadenceStatus', false)">
            Nowa kadencja
        </eSesjaModalHeader>
        <eSesjaModalBody>
            <p class="text-center">Kliknięcie "Potwiedzam" rozpocznie proces tworzenia nowej kadencji na podstawie wybranych danych w kreatorze. Proces ten jest <b style="color: red">nieodwracalny.</b></p>
            <br />
            <p class="text-center">Po pomyślnym ukończeniu przenoszenia wszystkich danych zostanie pobrany plik z danymi dostępowymi nowych użytkowników oraz zostaniesz automatycznie wylogowany.</p>
            <br />
            <p class="text-center">Zostanie także utworzony specjalny użytkownik z uprawnieniami logowania do minionej kadencji.</p>
           <br />
            <section class="d-flex justify-content-center">
               <ReCaptchaComponent v-model="token" />
           </section>
        </eSesjaModalBody>
        <eSesjaModalFooter>
            <eSesjaModalButtonCancel @close="$store.commit('setModalConfirmCreateNewCadenceStatus', false)">
                Anuluj
            </eSesjaModalButtonCancel>
            <eSesjaModalButtonSave @click="createNewCadence" :disabled="isSaveButtonDisabled">
                Potwierdzam
            </eSesjaModalButtonSave>
        </eSesjaModalFooter>
    </eSesjaModal>
</template>
<script charset="utf-8">
    import ReCaptchaComponent from "../../../BasicControls/ReCaptchaComponent.vue"
    import wizardNewCadenceService from "../../../../services/wizard.new.cadence.service";
    import userService from "../../../../services/user.service";
    export default {
        name: "ConfirmSetupNewCadenceModal",
        components: {
            ReCaptchaComponent
        },
        computed: {
            isHuman(){
                return this.token !== "";
            },
            isSaveButtonDisabled() {
                return this.isHuman === false || this.isBusy === true;
            }
        },
        data() {
            return {
                token: "",
                requestModel: {
                    transmision: false,
                    sessionGroups: [],
                    groupsWithContacts: [],
                    administrators: [],
                    templates: [],
                    newUsers: [],
                },
                isBusy: false,
            }
        },
        mounted() {
            this.requestModel.transmision = this.$store.state.wizardNewCadence.transmissionSettings;
            this.requestModel.sessionGroups = wizardNewCadenceService.allSelectedGroups() ?? [];
            this.requestModel.groupsWithContacts = this.$store.state.wizardNewCadence.selectedContactGroups ?? [];
            this.requestModel.administrators = wizardNewCadenceService.selectedAdministrators() ?? []
            this.requestModel.templates = wizardNewCadenceService.selectedTemplates() ?? [];
            this.requestModel.newUsers = this.$store.state.wizardNewCadence.usersList ?? [];
        },
        methods: {
            async createNewCadence() {
                try {
                    this.$store.commit("showLoader", true);
                    this.isBusy = true;
                    let response = await wizardNewCadenceService.createNewClientCadence(this.requestModel);

                    if (response.status !== 200) {
                        throw await Promise.reject(response);
                    }

                    await this.getLogins(parseInt(response.data));

                    await userService.logout();
                }
                finally {
                    this.$store.commit("hideLoader", false);
                    this.isBusy = false;
                }
            },

            async getLogins(newKid) {
                let response = await wizardNewCadenceService.getAccountsLoginsInfo(newKid);
                if (response.status !== 200) {
                    throw await Promise.reject(response)
                }

                const contentType = response.headers['content-type'];
                let a = document.createElement('a');
                var blob = new Blob([response.data], { 'type': contentType });
                a.href = window.URL.createObjectURL(blob);
                var filename = response.headers['content-disposition'].split("filename=")[1];

                filename = filename.substr(0, filename.indexOf(';'));
                filename = filename.replaceAll('"', '');
                a.download = filename
                a.click();

            },
        }
    }
</script>